<template>
  <div class='research_component'> 
    <div class="w-[1350px] mx-auto">
      <div class="fuk text-[40px] font-bold">强势教研翼</div>
      <div class="flex fuk0">
        <div 
          class="brs cursor-pointer w-[144px] h-[50px] text-[16px] font-bold text-[#111] bg-[#fff] flex items-center justify-center mr-[20px]"
          :class="[activeIndex === index ? 'active_tab' : '']"
          v-for="(item, index) in tabData" :key="item"
          @click="activeIndex = index"
        >
          {{ item }}
        </div>
      </div>
      <div >
        <img v-show="activeIndex === 0" class="w-[1400px]" src="../../../assets/images/advantage/publish1.png" alt="arrow">

        <div v-show="activeIndex === 1" class="relative">
          <img class="w-[1400px]" src="../../../assets/images/advantage/upgrade1.png" alt="专升本研究院">
          <!-- <el-tooltip effect="dark" popper-class="toolTip_content" :content="tyTipContent" placement="top">
            <img class="absolute top-[76%] left-[43.5%]" src="../../../assets/images/common/question_tip.svg" alt="问号">
          </el-tooltip> -->
          <!-- <el-tooltip effect="dark" popper-class="toolTip_content" :content="kkTipContent" placement="top">
            <img class="absolute top-[43%] left-[43.5%]" src="../../../assets/images/common/question_tip.svg" alt="问号">
          </el-tooltip> -->
        </div>
        <img v-show="activeIndex === 2" class="w-[1400px]" src="../../../assets/images/advantage/public_office.png" alt="公职研究院">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Research',
  data() {
    return {
      tabData: ['出版传媒研究院', '专升本教学研究院', '公职教学研究院'],
      activeIndex: 0,
      kkTipContent: '数据来源：尚普咨询集团，覆盖全国31个省、直辖市及自治区全渠道市场，通过专家、企业及终端渠道调研，对比全国（不含港澳台）范围内各品牌统招专升本培训情况，得出：库课，统招专升本培训（连续2年）通过率第一。统计时间：2023至2024学年，于2024年11月完成调研。',
      tyTipContent: '数据来源：尚普咨询集团，覆盖全渠道市场，通过专家、企业及终端渠道调研，对比河南省范围内各品牌统招专升本培训情况，得出：天一专升本，河南统招专升本培训（连续2年）通过率第一。统计时间：2023至2024学年，于2024年11月完成调研。'
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang='less' scoped>
.research_component {
  width: 100%;
  height: 0;
  padding-bottom: 38.854%; /* 1920/746 * 100% 设计稿的高度比上宽度乘以百分百 */
  background: url('../../../assets/images/advantage/bg_technology.png') no-repeat top center / contain;
  .active_tab {
    color: #fff;
    background: #E60020;
    border-radius: 4px;
  }
}

.fuk {
  padding-top: 60px !important;
  padding-bottom: 35px !important;
  margin: 0 auto !important;
  font-size: 32px !important;
}

@media screen and (min-width: 1920px) {
  .fuk {
    padding-top: 80px !important;
    padding-bottom: 60px !important;
    margin: 0 auto !important;
    font-size: 32px !important;
  }
}

.fuk0 {
  margin-left: auto !important;
  margin-bottom: 40px !important;
}

@media screen and (min-width: 1920px) {
  .fuk0 {
    margin-left: auto !important;
    margin-bottom: 60px !important;
  }
}

.brs {
  border-radius: 4px;
}

</style>
<style>
.toolTip_content {
  width: 276px;
  font-size: 12px;
  line-height: 20px;
}
</style>